import SiteApi from '../../Api/SiteApi/SiteApi';
import { $ } from '../bootstrap';

import MapHelper from './MapHelper';
import googleMapsAPI from './googleMapsAPI';

googleMapsAPI.whenActive(() => {
    $('div.google-map-markers').each(function loop() {
        markersInitialize(this);
    });
});

async function markersInitialize(mapElement: HTMLElement) {
    const $mapElement = $(mapElement);
    const mapId = parseInt($mapElement.data('map-id')) || 0;

    if (mapId > 0) {
        const googleMap = await SiteApi.googleMapWithMarkers(mapId);

        const mapHelper = new MapHelper(mapElement, {
            mapTypeId: googleMap.type,
            zoom: googleMap.zoom,
            center: googleMap,
            disableDefaultUI: true,
            zoomControl: true,
        });

        googleMap.markers.forEach((marker) => mapHelper.addMarker(marker));
    }
}

/*
 *  Example of usage:
 *
 *  <div class="google-map-markers" data-map-id="1" style="height: 400px"></div>
 *
 * */
